import React from 'react';
import { Button } from '@mui/material';

interface DialogActionButtonsProps {
  isEditMode: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
  isEditMode,
  onCancel,
  onSave,
}) => (
  <>
    <Button onClick={onCancel} color="inherit">
      Cancel
    </Button>
    <Button
      onClick={onSave}
      variant="contained"
      sx={{
        backgroundColor: '#162346',
        '&:hover': {
          backgroundColor: '#1a2a52',
        },
      }}
    >
      {isEditMode ? 'Update' : 'Add'} Address
    </Button>
  </>
);
